import {TileLayerOptions} from 'leaflet'

/**
 * @file
 * App Configuration
 *
 * This file provides the standard configuration of google maps
 */

export interface GmapPosition {
  lat: number,
  lng: number,
}

/**
 * Map Configuration
 */
export abstract class MapConfig {
  static readonly defaultCenter: GmapPosition = {
    lat: -15.7941,
    lng: -47.8825,
  }

  // Map Tile
  static readonly urlTemplate = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
  static readonly tileLayerOptions: TileLayerOptions = {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19,
  }

  static readonly truckIcon = './img/itrack/truck-location.svg'
  static readonly truckWithCheckinIcon = './img/itrack/truck-location-checkin.svg'
  static readonly truckCustomIcon = './img/itrack/truck-location-custom.svg'
  static readonly truckLateIcon = './img/itrack/truck-location-delayed.svg'

  static readonly truckMapSvg = './img/itrack/truck.svg'
  static readonly carMapSvg = './img/itrack/car.svg'
  static readonly motorcycleMapSvg = './img/itrack/motorcycle.svg'

}
